export function AuditLogField(target: any, fieldKey: string) {
    if (!target.constructor._fields) {
      target.constructor._fields = [];
    }
    target.constructor._fields.push(fieldKey);
}